import { render, staticRenderFns } from "./NonConformingProductsOnlyRead.vue?vue&type=template&id=6ea927eb&scoped=true&"
import script from "./NonConformingProductsOnlyRead.vue?vue&type=script&lang=js&"
export * from "./NonConformingProductsOnlyRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea927eb",
  null
  
)

export default component.exports